import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon, SunIcon, CalendarIcon, SproutIcon } from 'lucide-react';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const problems = [{
    icon: SproutIcon,
    text: "Usar tierra de 'parque' o sustratos baratos que se compactan y asfixian las raíces en 48 horas."
  }, {
    icon: CalendarIcon,
    text: 'Intentar cultivar especies de ciclo largo (como sandías o calabazas) en espacios que requieren gratificación instantánea.'
  }, {
    icon: SunIcon,
    text: "No entender el 'Mapa de Luz': poner plantas de sol pleno bajo la sombra proyectada del edificio de enfrente."
  }, {
    icon: XCircleIcon,
    text: "Regar por calendario ('cada lunes') en lugar de escuchar la necesidad real de la maceta en un entorno de concreto."
  }];
  return <section ref={ref} className="w-full py-16 md:py-24 bg-white" data-id="element-125">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-127">
          <div className="bg-[#D8F3DC] rounded-2xl p-8 md:p-12 mb-12" data-id="element-128">
            <p className="text-lg md:text-xl text-gray-800 leading-relaxed mb-6" data-id="element-129">
              Sostienes esa bolsa de lechuga en el supermercado que cuesta casi
              4 euros. Tres días después, acaba convertida en una masa viscosa
              en el fondo de tu nevera. Miras tu balcón: está vacío, lleno de
              trastos o con una planta que ni sabes cómo se llama y que está
              pidiendo auxilio.
            </p>
            <p className="text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-130">
              Hay una desconexión total entre lo que comes y lo que eres capaz
              de producir. Pero no tiene por qué ser así. Tu balcón no es un
              depósito de cajas viejas; es una unidad de producción de comida
              esperando a ser activada.
            </p>
          </div>

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D6A4F] mb-6" data-id="element-131">
            El Problema Real
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-132">
            La mayoría de los jóvenes urbanos fracasan con su huerto antes de
            empezar. Compran kits de regalo de Amazon con semillas viejas,
            intentan cultivar tomates en una esquina donde nunca da el sol o
            ahogan a sus plantas porque nadie les explicó que regar en maceta no
            es lo mismo que regar en un jardín.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-133">
            El resultado es siempre el mismo: tierra por todo el suelo, dinero
            tirado a la basura y la falsa creencia de que 'no tienes mano
            verde'. El problema no eres tú, es que estás intentando aplicar
            agricultura tradicional en un tercer piso.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-134">
          <h3 className="font-heading text-2xl md:text-3xl font-bold text-[#2D6A4F] mb-8 text-center" data-id="element-135">
            Por qué lo que intentaste no funcionó
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-136">
            {problems.map((problem, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: 0.3 + index * 0.1
          }} className="flex gap-4 p-6 bg-gray-50 rounded-xl border border-gray-200 hover:border-[#52B788] transition-colors" data-id="element-137">
                <div className="flex-shrink-0" data-id="element-138">
                  <problem.icon className="w-6 h-6 text-[#2D6A4F]" data-id="element-139" />
                </div>
                <p className="text-gray-700 leading-relaxed" data-id="element-140">{problem.text}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}